module.exports = __webpack_public_path__ + "static/caltex-6a2c21c67d21948bb430c768092e3e64.png";